/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {ADN_TARGETING_TYPES} from '../targeting-constants';
import {TargetingHelper} from '../targeting-helper';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-device-summary',
  template: `
    <ul class="list-unstyled">
      <li *ngFor="let prop of summaryKeys">
        <strong>{{ 'targeting.device.' + prop | translate }}</strong>: {{formatSelections(summary[prop])}}
      </li>
    </ul>
  `
})
export class DeviceSummaryComponent implements OnChanges {
  @Input() targets: any;

  summary: Record<string, string[]> = {};
  summaryKeys: string[] = [];

  constructor(private readonly translate: TranslateService) {
  }

  ngOnChanges(): void {
    this.summary = TargetingHelper.getSummary(this.targets, ADN_TARGETING_TYPES.device) || {};
    this.summaryKeys = Object.keys(this.summary);
  }

  formatSelections(selections: string[]): string {
    return _.map(selections, (selection) => {
      const key = 'targeting.device.' + selection;
      const tx = this.translate.instant(key);
      return tx === key ? selection : tx;
    }).join(', ');
  }
}
